<template>
    <v-card
        class="mx-auto itemCard pa-3"
        outlined
    >
        <v-row no-gutters>
            <v-col cols="12" md="4" class="mr-1">
                <v-text-field
                    hide-details="auto"
                    :label="$t('page.eventDetails.raceList.race-name')"
                    v-model="raceName"
                    :error-messages="
                        isError.raceName ? $t('page.eventDetails.raceList.is-errors.' + isError.message.raceName) : ''
                        "
                    style="margin: 10px 0"
                    outlined
                    dense
                    @input="sendMessage('raceName')"
                    :placeholder="placeholder.raceName"
                ></v-text-field>
            </v-col>
        </v-row>
        <v-row no-gutters v-if="!dropdown || open">
            <v-col cols="12" sm="3">
                <v-img
                    width="100%"
                    :src="imageUrl"
                    v-on:error="ImgError"
                    style="max-height: 200px; margin: 0 auto;"
                ></v-img>
                <v-row no-gutters>
                    <v-btn class="mc-center-b min-btn-w btnRaceImage" outlined @click="upload()">
                        {{ $t("dashboard.menu.promoter_dashboard.change_your_image") }}
                    </v-btn>
                    <input
                        style="display: none"
                        type="file"
                        id="uploadImage_"
                        name="uploadImage_"
                        accept="image/*"
                        @change="onImageChange($event)"
                        multipl
                    />
                </v-row>
            </v-col>
            <v-col cols="12" sm="8" class="bannerRaceImage">
                <v-row no-gutters>
                    <v-col cols="12" md="12" lg="12">
                        <v-img width="95%" style="margin: 1rem auto 4rem;" :src="imageUrlBanner" v-on:error="ImgErrorBanner"></v-img>
                    </v-col>
                    <v-col cols="12" md="12" lg="12">
                        <v-btn
                            style="width:95%;"
                            class="ma-2 btnRaceImage"
                            outlined
                            @click="upload()"
                        >{{ $t('dashboard.menu.raceDetails.change_your_image') }}</v-btn>
                        <input
                            style="display:none;"
                            type="file"
                            id="uploadImage_"
                            name="uploadImage_"
                            accept="image/*"
                            @change="onImageChange($event)"
                            multiple
                        />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <a class="controlOpen" @click="controlOpen" v-if="dropdown">
            <i :class="!open ? 'far fa-chevron-down' : 'far fa-chevron-up'"></i>
        </a>
    </v-card>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";

export default {
    mixins: [ apiCalls ],
    props: [ 'dropdown' ],
    data () {
        return {
            open: false,
            raceName: "",
            imageUrl: null,
            imgError: null,
            failed_image: true,
            imageUrlBanner: null,
            imgErrorBanner: null,
            isError: {
                raceName: false,
                message: {
                    raceName: ""
                }
            },
        };
    },
    computed: {
        placeholder: function () {
            return {
              raceName: this.$t("page.eventDetails.raceList.placeholder.race-name")
            };
        }
    },
    methods: {
        controlOpen() {
          this.open = !this.open;
        },
        async loadImageUrl() {
            const response = await this.api("get", "/api/v1/users/current");
            const user = response.message;

            var imageUrl_ = user.existFile
                ? process.env.VUE_APP_ROOT + "/laravel/public" + user.image
                : this.failed_image
                ? process.env.VUE_APP_ROOT + user.image
                : require("@/assets/images/orgPlaceholder.jpg.png");

            this.imageUrl = imageUrl_;
            this.imageUrlBanner = imageUrl_;
        },
        async ImgError() {
            this.failed_image = false;
            this.imageUrl = require("@/assets/images/orgPlaceholder.jpg.png");
        },
        upload() {
            document.getElementById("uploadImage_").click();
        },
        async onImageChange(e) {
            this.uploadImage_ = e.target.files[0];
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            this.createImage(files[0]);
            this.fileName = files[0].name;
            this.uploadImage();
        },
        async createImage(file) {
            let reader = new FileReader();
            let vm = this;
            reader.onload = (e) => {
                vm.image = e.target.result;
            };

            reader.readAsDataURL(file);
        },
        async uploadImage() {
            /*const data = new FormData();
            data.append("image", this.uploadImage_);
            data.append("fileName", this.fileName);

            let axiosConfig = {
                headers: { "content-type": "multipart/form-data" },
            };

            const response = await axios
                .put(
                `${this.root}/laravel/public/api/v1/promoter/profile/picture`,
                data,
                axiosConfig
                )
                .catch(
                function (error) {
                    const status = error.response.status;

                    switch (status) {
                    case 401:
                        window.location.href = `${this.root}/login?message=You20are%20logged%20out!`;
                        break;
                    }
                }.bind(this)
                );
            if (response.data.success == 1) {
                this.imageUrl =
                process.env.VUE_APP_ROOT + "/laravel/public" + response.data.message;
                this.$emit("image", this.imageUrl);
            }*/
        },
        async ImgErrorBanner() {
            this.failed_image = false;
            this.imageUrlBanner = "https://placehold.it/600x90?text=600 x 90 Ad";
        }
    },
    created () {
        this.loadImageUrl();
    }
}
</script>

<style lang="scss" scoped>
.itemCard {background-color: var(--v-lighten-base) !important;}    
.controlOpen {position: absolute; top: 5px; right: 15px;}
.bannerRaceImage {
    display: flex;
    > div.row {
        margin: auto 0 1rem 0;
        div:last-childlast {
            padding: 1rem 15px;
        }
    }
}
.btnRaceImage {
    background-color: var(--v-primary-base) !important;  
    color: var(--v-lighten-base) !important;

    @media (max-width: 1500px) {
        min-width: 0px !important;
        width: 100%;
        min-height: 36px;
        height: auto !important;
        white-space: normal;

        > span {display: block;}
    }
    @media (max-width: 959px) {
        
        
        
    }
}
</style>